import { useState, useEffect, useCallback } from "react";

export function WahaPage() {
  const [status, setStatus] = useState<{ connected?: boolean; configured?: boolean; error?: string } | null>(null);
  const [loading, setLoading] = useState(true);
  const [testing, setTesting] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("affiliate_flow_auth_token");
      const response = await fetch("/api/v1/integrations/waha/status", {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      const data = await response.json();
      if (data.success) {
        setStatus(data.data);
      }
    } catch {
      // ignore
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const testConnection = async () => {
    setTesting(true);
    try {
      const token = localStorage.getItem("affiliate_flow_auth_token");
      const response = await fetch("/api/v1/integrations/waha/test", {
        method: "POST",
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      const data = await response.json();
      if (data.success) {
        setStatus(data.data);
      }
    } catch {
      // ignore
    } finally {
      setTesting(false);
    }
  };

  const syncGroups = async () => {
    setTesting(true);
    try {
      const token = localStorage.getItem("affiliate_flow_auth_token");
      await fetch("/api/v1/integrations/waha/sync-groups", {
        method: "POST",
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
    } catch {
      // ignore
    } finally {
      setTesting(false);
    }
  };

  if (loading) {
    return <div className="h-32 animate-pulse rounded-lg bg-muted" />;
  }

  return (
    <div className="max-w-xl space-y-4">
      <div className="rounded-lg border bg-card p-5">
        <h3 className="mb-4 font-medium">Status da Conexão WAHA</h3>
        <dl className="space-y-2 text-sm">
          <div className="flex justify-between">
            <dt className="text-muted-foreground">Chave configurada</dt>
            <dd>{status?.configured ? "Sim" : "Não"}</dd>
          </div>
          <div className="flex justify-between">
            <dt className="text-muted-foreground">Conexão</dt>
            <dd className={status?.connected ? "text-green-600" : "text-red-600"}>
              {status?.connected ? "Disponível" : "Indisponível"}
            </dd>
          </div>
          {status?.error && (
            <div className="rounded-md bg-destructive/10 p-2 text-xs text-destructive">
              {status.error}
            </div>
          )}
        </dl>
        <div className="mt-4 flex gap-2">
          <button
            onClick={testConnection}
            disabled={testing}
            className="rounded-md bg-primary px-3 py-2 text-sm text-primary-foreground disabled:opacity-50"
          >
            Testar conexão
          </button>
          <button
            onClick={syncGroups}
            disabled={testing}
            className="rounded-md border px-3 py-2 text-sm disabled:opacity-50"
          >
            Atualizar grupos
          </button>
        </div>
      </div>

      <div className="rounded-lg border bg-card p-5">
        <h3 className="mb-2 font-medium">Configuração</h3>
        <div className="space-y-2 text-sm text-muted-foreground">
          <p>
            Configure as variáveis de ambiente <code>WAHA_BASE_URL</code>, <code>WAHA_API_KEY</code> e{" "}
            <code>WAHA_SESSION</code> no arquivo <code>.env</code>.
          </p>
          <p>
            Para receber webhooks, configure o endpoint:{" "}
            <code className="rounded bg-muted px-1">/api/v1/webhooks/waha</code>
          </p>
        </div>
      </div>
    </div>
  );
}
